import { FC, JSX } from "react";
import { Text, View } from "react-native";
import { Svg } from "react-native-svg";
import { IGetCurrentUserResponse } from "@/_store/currentUser/contracts";
import List, { ListItems } from "@/app/components/List";
import StatsBlock, { IStatItem } from "@/app/components/StatsBlock";
import CustomButton from "@/app/components/CustomButton";
import { formatInsuranceAmount } from "@/_utils/formatAmount";
import { DATE_FORMAT } from "@/_utils/formatDate";
import AlertIcon from "@/assets/icons/main/redAlert.svg";
import dayjs from "dayjs";
import { formatChecksLeft, formatDaysLeft } from "@/_utils/deadlineItems";

interface ICompanyProps {
  daysLeft?: number;
  isLoading?: boolean;
  subscriptionData?: IGetCurrentUserResponse;
  isSubscriptionAlmostOver: boolean;
}

const Subscription: FC<ICompanyProps> = ({
  daysLeft,
  isLoading,
  subscriptionData,
  isSubscriptionAlmostOver,
}): JSX.Element => {
  const {
    name,
    price,
    end_date,
    total_reports,
  } = subscriptionData?.subscription ?? {};

  const subscriptionOverText: string = daysLeft === 0
    ? "Срок вашей подписки истёк. На вашу почту был направлен счет для оплаты нового периода."
    : "Ваша подписка скоро закончится. На вашу почту был направлен счет для оплаты нового периода.";

  const statsInfoItems: IStatItem[] = [
    {
      info: `${ daysLeft !== undefined ? formatDaysLeft(daysLeft) : ""} до окончания подписки`,
      value: daysLeft,
      isFullWidth: true
    },
    {
      info: "Проверок компаний и ИП осталось",
      value: "Безлимит"
    },
    {
      info: total_reports !== undefined ? formatChecksLeft(total_reports) : "Информация отсутствует",
      value: total_reports
    },
  ];

  const subscriptionInfoItems: ListItems[] = [
    { label: "Тариф", value: name },
    { label: "Стоимость", value: price ? formatInsuranceAmount(price) : null },
    { label: "Срок действия", value: end_date ? dayjs(end_date).format(DATE_FORMAT) : null },
  ];

  return (
    <View>
      {isSubscriptionAlmostOver && (
        <View className="mb-5 p-3 rounded-[20px] bg-gray-opacity">
          <View className="flex flex-row mb-3">
            <View>
              <Svg className="w-6 h-6 mr-3"><AlertIcon /></Svg>
            </View>
            <Text className="text-base text-left">{subscriptionOverText}</Text>
          </View>
          {/*//TODO: Добавить обработчик, как будет готово АПИ*/}
          <CustomButton
            title="Отправить счет повторно"
            type="filled"
            style={{ backgroundColor: "rgba(245, 34, 45, 0.10)" }}
            textStyle={{ color: "#F5222D" }}
          />
        </View>
      )}
      <View className="mb-5">
        <StatsBlock stats={statsInfoItems} isLoading={isLoading} />
      </View>
      <List items={subscriptionInfoItems} isLoading={isLoading} />
    </View>
  );
};

export default Subscription;
